import { render, staticRenderFns } from "./IranValidityManager.vue?vue&type=template&id=6f6310ca&scoped=true"
import script from "./IranValidityManager.vue?vue&type=script&lang=js"
export * from "./IranValidityManager.vue?vue&type=script&lang=js"
import style0 from "./IranValidityManager.vue?vue&type=style&index=0&id=6f6310ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6310ca",
  null
  
)

export default component.exports